import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Params,
  Router,
  RouterStateSnapshot, UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

export const EVENT_APP_ROUTE_PARAM_NAME = 'eventsAppRoute';
@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // The eventsAppRoute queryParam comes from Magnolia if a page is reloaded (or a deep-link) with the event-app,
    // Magnolia adds the route to eventsAppRoute for Angular to re-route internally, for example Magnolia re-directs from:
    // .../event/events-app/event/registration?id=Christmas_Party3380135827
    // to
    // .../event?id=Christmas_Party3380135827&eventsAppRoute=/event/registration
    const eventsAppRoute = next.queryParams[EVENT_APP_ROUTE_PARAM_NAME];

    // If the url has a fragment (e.g. #/event/sessions?id=tim_Banking123) that starts with '/event' then it's a link from
    // older dynamics outbound emails or older deep links such as,
    // /de/insights/events/test-event#/event/sessions?id=Christmas_Party3380135827
    const fragment = next.fragment;

    if (fragment && fragment.startsWith('/event')) {
      const urlTree = this.router.parseUrl(fragment);

      return urlTree;
    }

    // Does url contain the queryParam 'eventsAppRoute' which is set by Magnolia redirect?
    if (eventsAppRoute) {
      // Create urlTree and add any existing queryParams
      const urlTree = this.router.parseUrl(eventsAppRoute);
      const queryParamsClone: Params = {};
      Object.entries(next.queryParams).forEach(([key, value]) => {
        if (key !== EVENT_APP_ROUTE_PARAM_NAME) {
          queryParamsClone[key] = value;
        }
      });
      urlTree.queryParams = queryParamsClone;

      return urlTree;
    } else {
      return true;
    }
  }
}
